(function($) {
  'use strict';

  var globalVariables = {
    body: $('body')
  };

  var appFunction = {
    anchorFunction: '*',
    biggerlinkFunction: '*',
    browserFunction: '*',
    cookieFunction: '*',
    navigationFunction: '*',
    parallaxFunction: '*',
    mediumzoomFunction: '*',
    scrollFunction: '*'
  };

  $.each(appFunction, function(funcName, condition) {
    if (
      ( typeof condition === 'string' && $('body').hasClass(condition) ) ||
      ( typeof condition === 'object' && condition.length ) ||
      ( typeof condition === 'string' && condition === '*')
    ) {
      try {
          window[funcName].call(this, globalVariables);
      } catch (e) {
          console.error(funcName + ' is not a function');
          console.log(e);
      }
    } else if (typeof window[funcName] !== 'function') {
      console.warn(funcName + ' is not a function');
    }
  });

})(jQuery);
